import React from "react";
import Dropdown from 'react-dropdown';
import './filter_contracts.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";

const FilterOptions = ({data, dropdownOptions, changeOption, selectedValue}) => {
    const handleChangeOption = (type, event) => {
        const value = event.value;
        changeOption(value, type);

    };
    return (
        <div className="filter-options">
            <div className="filter-option">

                <h3 className={'filter-title'}>
                    {data.title}
                </h3>
                <Dropdown
                    options={dropdownOptions.map(function(option) {
                        return(option)
                    })}
                    onChange={handleChangeOption.bind(this, 'category')}
                    value={selectedValue}
                    placeholder={'Tutti i Dipartimenti e le Scuole'}
                    className="dropdown-contracts"
                    arrowClosed={<span className="arrow-closed" />}
                    arrowOpen={<span className="arrow-open" />}
                />

            </div>
        </div>
    );
};

const FilterItems = ({ data }) => {
    return (
        <div className="filter-items">
            {data.map(function(item, index){
                return (
                    <div className="filter-card" key={index}>
                        <div className={'wrap-data'}>
                            <p className={'code-card'}><span>Codice Concorso:</span> {item.card_code}</p>
                            <h3 className={'title-card'}>{item.card_title}</h3>
                            <p className={'publication-card'}>{item.card_date}</p>
                            <p className={'subtitle-card'}>{item.card_subtitle}</p>
                            <p className={'card-scadenza'}><span>Scadenza:</span> {item.card_scadenza}</p>
                        </div>
                        <div className={'link-btn-wrapper'}>
                            <a href={item.url_white} className={'btn-white'} target={'_blank'} rel="noreferrer noopener">{item.cta_white}</a>
                            <a href={item.url_blue} className={'web-link'} target={'_blank'} rel="noreferrer noopener">{item.cta_blue}</a>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

class FilterContracts extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            contracts:'',
            selectedValue: null
        }
    }

    filterItems(val, type, data) {
        // if selectedValue is "Tutti i Dipartimenti" type of filtering return all (initial) data array
        try {
            if(val.toLowerCase().indexOf('dipartimenti') > -1){
                // eslint-disable-next-line no-unused-vars
                let type = 'all';
            }
        }
        catch(e) {
            console.error(e);
        }
        // take the value selected in the dropdown and pass with state 'selectedValue' to FilterOption
        this.setState({selectedValue: val})
        switch (type) {
            case 'category':
                this.setState({category: val});
                break;
            case 'all':
                this.setState({category: data});
                break;
            default:
                break;
        }
    }

    componentRender(data) {
        var filteredItems = data.contracts;
        var state = this.state;
        // for each category return the the item of contract array
        ['category'].forEach(function(filterBy) {
            var filterValue = state[filterBy];
            if (filterValue) {
                filteredItems = filteredItems.filter(function(item) {
                    // return category from contracts array
                    return item[filterBy].toLowerCase() === filterValue;
                });
            }
        });
        // filter dropdown category
        let dropdownArray = data.dropdown_menu.map(function(item) {
            // return category from dropdown_menu array
            return item.category.toLowerCase()
        });
        dropdownArray = dropdownArray.filter((val, i, self) => self.indexOf(val)===i);
        // create voice 'Tutti i dipartimenti' - unshift will push at the first position of the array dropdownArray
        // the value "Tutti i Dipartimenti e le Scuole".
        dropdownArray.unshift('Tutti i Dipartimenti e le Scuole');

        return (
            <>
                <div className="container-filter-contracts">
                    <FilterOptions
                        data={this.state.data}
                        dropdownOptions={dropdownArray}
                        changeOption={this.filterItems.bind(this)}
                        selectedValue = {this.state.selectedValue}
                    />
                    <div className="filter-form">
                        <FilterItems data={filteredItems} />
                    </div>
                </div>
            </>
        )
    }
}

export default FilterContracts;
